import MultiStepModalWizard from './MultiStepModalWizard';

export type { MultiStepModalWizardProps } from './MultiStepModalWizard';

export default MultiStepModalWizard;

export { MultiStepModalWizard };
